import './App.css';
import './css/myStyle.css';
import Welcome from './components/welcome';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
    <Welcome/>
    </>
  );
}

export default App;
